// Centralized company social/contact links.
// Update the values here to change the links used anywhere in the app —
// currently used by the Contact page's social icons.

export const FACEBOOK_URL = "https://www.facebook.com/share/1DCZ8MKGUa/";
export const INSTAGRAM_URL = "https://www.instagram.com/goye_2026?igsh=MWd2ZXU2cjBkbWkzbw==";

export const SOCIAL_LINKS = {
    whatsapp: "https://api.whatsapp.com/send/?phone=9943042369&text&type=phone_number&app_absent=0",
    linkedin: "https://www.linkedin.com/in/life-changers-ind-5696b720a/",
    twitter: "https://x.com/Lifechangersind?t=Yc8WfiFeA611U-8oLd15sg&s=09",
    facebook: FACEBOOK_URL,
    instagram: INSTAGRAM_URL,
};

export default SOCIAL_LINKS;